export default __webpack_public_path__ + "static/media/author-8.4eea48b4.png";